define.alias("shared/utils/insert-text-at-cursor", "preview-grid/utils/insert-text-at-cursor");